export const STORE_INSIGHTS_QUERY = gql`
  query StoreInsightsQuery(
    $integrationId: String!
    $limit: Int
    $surface: StoreInsightSurface
  ) {
    storeInsights(
      integrationId: $integrationId
      limit: $limit
      surface: $surface
    ) {
      id
      type
      title
      summary
      prompt
      category
      priority
      severity
      changeStatus
      materialSignature
      scenarioId
      metricKey
      payload
      generatedAt
      firstSeenAt
      lastSeenAt
      userState {
        dismissedAt
        snoozedUntil
        suppressionSignature
      }
      createdAt
    }
  }
`;

const STORE_INSIGHT_RESULT_FIELDS = gql`
  fragment StoreInsightResultFields on StoreInsight {
    id
    priority
    severity
    changeStatus
    materialSignature
    userState {
      dismissedAt
      snoozedUntil
      suppressionSignature
    }
  }
`;

export const SNOOZE_STORE_INSIGHT_MUTATION = gql`
  mutation SnoozeStoreInsightMutation($id: String!) {
    snoozeStoreInsight(id: $id) {
      ...StoreInsightResultFields
    }
  }
  ${STORE_INSIGHT_RESULT_FIELDS}
`;

export const DISMISS_STORE_INSIGHT_MUTATION = gql`
  mutation DismissStoreInsightMutation($id: String!) {
    dismissStoreInsight(id: $id) {
      ...StoreInsightResultFields
    }
  }
  ${STORE_INSIGHT_RESULT_FIELDS}
`;

export const RESTORE_STORE_INSIGHT_MUTATION = gql`
  mutation RestoreStoreInsightMutation($id: String!) {
    restoreStoreInsight(id: $id) {
      ...StoreInsightResultFields
    }
  }
  ${STORE_INSIGHT_RESULT_FIELDS}
`;
